import React from 'react';
import StepProgressBar, { StepDefinition } from './StepProgressBar';
import WizardFooter from './WizardFooter';
import { selectScreenSize } from 'redux/session/selectors';
import { useSelector } from 'react-redux';
import { SCREEN_SIZE } from 'types';

interface WizardShellProps {
  title: string;
  subtitle: string;
  steps: StepDefinition[];
  currentStepIndex: number;
  /** Pass true once the final step's async work is done to mark it as completed. */
  isLastStepCompleted?: boolean;
  /** Marks a step as failed in the progress bar. */
  errorStepIndex?: number;
  /** Optional percent positions for progress bar steps after the first. */
  stepPositionPercents?: number[];
  children: React.ReactNode;
  onBack?: () => void;
  showBack?: boolean;
  primaryAction: {
    label: string;
    onClick: () => void;
    disabled?: boolean;
    loading?: boolean;
    show?: boolean;
  };
}

const WizardShell: React.FC<WizardShellProps> = ({
  steps,
  currentStepIndex,
  isLastStepCompleted = false,
  errorStepIndex,
  stepPositionPercents,
  children,
  onBack,
  showBack = true,
  primaryAction
}) => {
  const screenSize = useSelector(selectScreenSize);
  return (
    <div className="wizard-shell">
      {screenSize && screenSize !== SCREEN_SIZE.SM && (
        <div className="wizard-shell__progress-bar">
          <StepProgressBar
            steps={steps}
            currentStepIndex={currentStepIndex}
            isLastStepCompleted={isLastStepCompleted}
            errorStepIndex={errorStepIndex}
            stepPositionPercents={stepPositionPercents}
          />
        </div>
      )}
      <div className="wizard-shell__content">
        <div className="wizard-shell__inner">
          <div className="wizard-shell__inner-content">{children}</div>
          <WizardFooter
            onBack={onBack}
            showBack={showBack}
            primaryLabel={primaryAction.label}
            onPrimaryClick={primaryAction.onClick}
            primaryDisabled={primaryAction.disabled}
            primaryLoading={primaryAction.loading}
            showPrimary={primaryAction.show ?? true}
          />
        </div>
      </div>
    </div>
  );
};

export default WizardShell;
